/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=47f6137e&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=47f6137e&lang=less"
import "./index.vue?vue&type=style&index=1&id=47f6137e&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__